import classNames from 'classnames';

/**
 * Utility function for combining class names
 * A lightweight wrapper around classnames for better developer experience
 *
 * @param inputs - Class names to combine (strings, objects, arrays, etc.)
 * @returns Combined class name string
 *
 * @example
 * cn('base-class', 'conditional-class', { 'active': isActive })
 * cn(['class1', 'class2'], { 'hidden': isHidden })
 */
export function cn(...inputs: Parameters<typeof classNames>): string {
  return classNames(...inputs);
}
